export default __webpack_public_path__ + "static/grow2-8b8978b12cdc6eda2b107d46895ccdd5.png";